export type FeatureSwitchQuery = { [key: string]: string };

enum FeatureSwitchQueryGroupType {
  classroom = "class",
  community = "community",
  school = "school",
  classOwner = "classOwner",
  user = "user",
}

export class FeatureSwitchQueryBuilder {
  static buildQuery(
    entityId: string,
    schoolId: string,
    communityId: string,
    classroomIds: string[],
    userSwitches: string[],
    schoolSwitches: string[],
    classroomSwitches: string[],
    communitySwitches: string[],
    classOwnerSwitches?: string[],
    classOwnerId?: string,
    featureSetId?: string,
    locale?: string,
    countryCode?: string
  ): FeatureSwitchQuery {
    const query: FeatureSwitchQuery = featureSetId ? { featureSetId } : {};

    if (userSwitches.length && entityId.length) {
      FeatureSwitchQueryBuilder.addFeatureSwitchGroup(
        query,
        FeatureSwitchQueryGroupType.user,
        entityId,
        userSwitches,
        locale || "en-US", // preserve existing behavior for user FS
        countryCode
      );
    }

    if (communitySwitches.length && communityId.length) {
      FeatureSwitchQueryBuilder.addFeatureSwitchGroup(
        query,
        FeatureSwitchQueryGroupType.community,
        communityId,
        communitySwitches,
        locale,
        countryCode
      );
    }

    if (schoolSwitches.length && schoolId.length) {
      FeatureSwitchQueryBuilder.addFeatureSwitchGroup(
        query,
        FeatureSwitchQueryGroupType.school,
        schoolId,
        schoolSwitches,
        locale,
        countryCode
      );
    }

    for (const classroomId of classroomIds) {
      if (classroomSwitches.length) {
        FeatureSwitchQueryBuilder.addFeatureSwitchGroup(
          query,
          FeatureSwitchQueryGroupType.classroom,
          classroomId,
          classroomSwitches,
          locale,
          countryCode
        );
      }
    }

    // classOwner switches are checked against the current class owner.
    // If its not a classroom island, we don't check any classOwner switches
    if (classOwnerSwitches?.length && classOwnerId) {
      FeatureSwitchQueryBuilder.addFeatureSwitchGroup(
        query,
        FeatureSwitchQueryGroupType.classOwner,
        classOwnerId,
        classOwnerSwitches,
        locale,
        countryCode
      );
    }
    return query;
  }

  private static addFeatureSwitchGroup(
    query: FeatureSwitchQuery,
    groupType: FeatureSwitchQueryGroupType,
    id: string,
    featureSwitches: string[],
    locale?: string,
    countryCode?: string
  ) {
    const groupName = groupType === FeatureSwitchQueryGroupType.classroom ? `${groupType}-${id}` : groupType;
    query[`${groupName}Id`] = id;
    query[`${groupName}Switches`] = featureSwitches.join(",");
    if (locale) {
      query[`${groupName}Locale`] = locale;
    }
    if (countryCode) {
      query[`${groupName}CountryCode`] = countryCode;
    }
  }
}
